var map = {
	"./ico_adc.png": "c71c",
	"./ico_captain.png": "4227",
	"./ico_captain_active.png": "928b",
	"./ico_coa.png": "17d0",
	"./ico_coach.png": "f2d2",
	"./ico_coroa.png": "c978",
	"./ico_coroa_active.png": "521a",
	"./ico_coroa_active2.png": "ca82",
	"./ico_disc.png": "bbce",
	"./ico_espada.png": "21b5",
	"./ico_face.png": "b537",
	"./ico_face2.png": "d3a0",
	"./ico_jng.png": "91fc",
	"./ico_jun.png": "0bd3",
	"./ico_mid.png": "4fc1",
	"./ico_perdedor_active.png": "a58d",
	"./ico_select_player.png": "3a31",
	"./ico_select_player2.png": "6b01",
	"./ico_sucesso.png": "d17a",
	"./ico_sup.png": "3748",
	"./ico_top.png": "0556",
	"./ico_trophy.png": "65a7",
	"./ico_twitter.png": "917c",
	"./ico_twitter2.png": "a49a",
	"./ico_vencedor.png": "21cf",
	"./ico_vencedor2_active.png": "b16e",
	"./ico_vencedor_active.png": "f123",
	"./ico_whatsapp.png": "9847"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "29e9";